'use client';

import { useState, useEffect, useRef, useCallback } from 'react';

/**
 * @function useComponentVisible
 * @description - Function to get visibility of dropdown menu
 * @param {boolean} initialIsVisible - Initial Visibility Value
 * @returns {boolean} -Visibility of dropdown on click of links
 */
export default function useComponentVisible(initialIsVisible) {
  const [isComponentVisible, setIsComponentVisible] = useState(initialIsVisible);
  const ref = useRef(null);

  /**
   * @function handleHideDropdown
   * @description - Function to handle to hide dropdown
   * @param {event} event - An action or occurrence that happens in the browser
   */
  const handleHideDropdown = useCallback(event => {
    if (event.key === 'Escape') {
      setIsComponentVisible(false);
    }
  }, []);

  /**
   * @function handleClickOutside
   * @description - Function to handle outside click of links
   * @param {event} event - An action or occurrence that happens in the browser
   */
  const handleClickOutside = useCallback(event => {
    if (ref.current && !ref.current.contains(event.target)) {
      setIsComponentVisible(false);
    }
  }, []);

  useEffect(() => {
    document.addEventListener('keydown', handleHideDropdown, true);
    document.addEventListener('click', handleClickOutside, true);
    return () => {
      document.removeEventListener('keydown', handleHideDropdown, true);
      document.removeEventListener('click', handleClickOutside, true);
    };
  }, [handleHideDropdown, handleClickOutside]);

  return { ref, isComponentVisible, setIsComponentVisible };
}
